import { render } from "./ListPICAgensiView.vue?vue&type=template&id=141b330a"
import script from "./ListPICAgensiView.vue?vue&type=script&lang=js"
export * from "./ListPICAgensiView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__